import React from 'react';
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';
import uuid from 'react-uuid';
import FormHelper from 'helpers/FormHelper';
import { ReactComponent as CloudGold } from 'icons/cloud_gold.svg';
import Dragger from 'antd/lib/upload/Dragger';
import Radio from 'components/radio';
import UIHelper from 'helpers/UIHelper';
import { Descriptions } from 'antd';

const InfoSection = ({
  leasingsMeetingTypes,
  asset,
  leasingsManagers,
  leasingsRooms,
  leasingsContacts,
  disabledData,
  visitTypeDisabled,
}) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Referente brand')} name='leasings_contact_id'>
          <Select
            placeholder={t('Referente brand')}
            {...UIHelper.getSelectSearchProps()}
          >
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            {leasingsContacts.map((company) => (
              <Select.Option key={company.value} value={company.value}>
                {company.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={9}>
        <Form.Item label={t('Azienda')} name='company_name'>
          <Input disabled placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>

      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Leasing manager')} name='leasings_manager_id'>
          <Select
            placeholder={t('Leasing manager')}
            {...UIHelper.getSelectSearchProps('title')}
          >
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            {leasingsManagers.map((company) => (
              <Select.Option key={company.value} value={company.value}>
                {company.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Asset di riferimento')} name='leasings_asset_id'>
          <Select
            placeholder={t('Asset di riferimento')}
            {...UIHelper.getSelectSearchProps()}
          >
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            {asset.map((company) => (
              <Select.Option key={company.value} value={company.value}>
                {company.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Unità di riferimento')} name='leasings_room_id'>
          <Select placeholder={t('Unità di riferimento')}>
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            {leasingsRooms.map((company) => (
              <Select.Option key={company.value} value={company.value}>
                {company.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9} />

      <Col span={6} />
      <Col span={9}>
        <Form.Item
          label={t('Tipo di incontro')}
          name='leasings_meeting_type_id'
        >
          <Select placeholder={t('Stato contatto')}>
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            {leasingsMeetingTypes.map((meetingType) => (
              <Select.Option key={meetingType.value} value={meetingType.value}>
                {meetingType.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Data incontro')} name='visit_date'>
          <DatePicker format={'DD MMMM YYYY'} style={{ width: '100%' }} />
        </Form.Item>
      </Col>

      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Titolo')} name='title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Oggetto dell’incontro')} name='visit_subject'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>

      <Col span={6} />
      <Col span={9}>
        <Form.Item
          label={t('Persone presente all incontro')}
          name='visit_persons'
        >
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9} />

      <Col span={6}>
        <Typography.Title level={3}>
          {t('Modalità di incontro')}
        </Typography.Title>
      </Col>
      <Col span={18}>
        <Form.Item label='' name='visit_mode'>
          <Radio.Group style={{ width: '100%' }} defaultValue={['']}>
            <Row key={uuid()}>
              <Col span={6} key={uuid()}>
                <Radio value={'by_person'}>{t('Di persona')}</Radio>
              </Col>
              <Col span={6} key={uuid()}>
                <Radio value={'by_phone'}>{t('Telefonico')}</Radio>
              </Col>
              <Col span={6} key={uuid()}>
                <Radio value={'by_videocall'}>{t('Videocall')}</Radio>
              </Col>
              <Col span={6} key={uuid()}>
                <Radio value={'other'}>
                  {t('Altro (specificare a fondo pagina nelle note)')}
                </Radio>
              </Col>
            </Row>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col span={6}>
        <Typography.Title level={3}>{t('Dati economici')}</Typography.Title>
      </Col>
      <Col span={18}>
        <Form.Item name='is_edit_data' valuePropName={'checked'}>
          <Checkbox disabled={visitTypeDisabled}>{t('Si')}</Checkbox>
        </Form.Item>
      </Col>
      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Affitto minimo')} name='min_rent_rate'>
          <Input
            disabled={disabledData || visitTypeDisabled}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Service charge')} name='service_charge'>
          <Input
            disabled={disabledData || visitTypeDisabled}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>

      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Affitto variabile')} name='rent_variable'>
          <Input
            disabled={disabledData || visitTypeDisabled}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Rachet')} name='rachet'>
          <Input
            disabled={disabledData || visitTypeDisabled}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>

      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Break option')} name='break_option'>
          <Input
            disabled={disabledData || visitTypeDisabled}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Durata contrattuale')} name='contract_duration'>
          <Input
            disabled={disabledData || visitTypeDisabled}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>

      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Uplift')} name='uplift'>
          <Input
            disabled={disabledData || visitTypeDisabled}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item
          label={t('Capital contribution')}
          name='capital_contribution'
        >
          <Input
            disabled={disabledData || visitTypeDisabled}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>

      <Col span={6}>
        <Typography.Title level={3}>{t('Allegati')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Allegato 1')}>
          <Form.Item
            name='first_file'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
          >
            <Dragger
              name='file'
              multiple={false}
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <CloudGold />
              </p>
              <p className='ant-upload-text'>
                {t('Drag & drop files, or browse in your files')}
              </p>
            </Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
            <Descriptions.Item label={`${t('Formati accettati')}:`}>
              PDF WORD XLS XLSX PPTX CSV
            </Descriptions.Item>
            <Descriptions.Item label={`${t('Dimensione massima')}:`}>
              20MB
            </Descriptions.Item>
          </Descriptions>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Allegato 2')}>
          <Form.Item
            name='second_file'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
          >
            <Dragger
              name='file'
              multiple={false}
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <CloudGold />
              </p>
              <p className='ant-upload-text'>
                {t('Drag & drop files, or browse in your files')}
              </p>
            </Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
            <Descriptions.Item label={`${t('Formati accettati')}:`}>
              PDF WORD XLS XLSX PPTX CSV
            </Descriptions.Item>
            <Descriptions.Item label={`${t('Dimensione massima')}:`}>
              20MB
            </Descriptions.Item>
          </Descriptions>
        </Form.Item>
      </Col>
      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Hot')}>
          <Form.Item
            name='hot_file'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
          >
            <Dragger
              name='file'
              multiple={false}
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <CloudGold />
              </p>
              <p className='ant-upload-text'>
                {t('Drag & drop files, or browse in your files')}
              </p>
            </Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
            <Descriptions.Item label={`${t('Formati accettati')}:`}>
              PDF WORD XLS XLSX PPTX CSV
            </Descriptions.Item>
            <Descriptions.Item label={`${t('Dimensione massima')}:`}>
              20MB
            </Descriptions.Item>
          </Descriptions>
        </Form.Item>
      </Col>
      <Col span={9} />

      <Col span={6}>
        <Typography.Title level={3}>{t('Note')}</Typography.Title>
      </Col>
      {/* <Col span={9}>
        <Form.Item label={t('Outcome dell’incontro')} name='outcome_note'>
          <Input.TextArea placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col> */}
      <Col span={18}>
        <Form.Item label={t('Note commerciale')} name='commercial_note'>
          <Input.TextArea placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>

      <Col span={6}>
        <Typography.Title level={3}>{t('Stato trattativa')}</Typography.Title>
      </Col>
      <Col span={18}>
        <Form.Item name={'status'}>
          <Radio.Group disabled={visitTypeDisabled}>
            <Radio value={'in_progress'}>{t('In corso')}</Radio>
            <Radio value={'done'}>{t('Conclusa')}</Radio>
            <Radio value={'resend'}>{t('Rinviata')}</Radio>
            <Radio value={'failed'}>{t('Fallita')}</Radio>
            <Radio value={'not_interested'}>{t('Non interessati')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
